class SearchPaginationService {
    getPagination(searchPage, pages) {
        const current:number = searchPage;
        const last:number = pages;
        const delta:number = 2;
        const left:number = current - delta;
        const right:number = current + delta + 1;
        const range = [];
        const rangeWithDots = [];
        let l:number;

        for (let i = 1; i <= last; i++) {
            if (i == 1 || i == last || i >= left && i < right) {
                range.push(i);
            }
        }

        for (const i of range) {
            if (l) {
                if (i - l === 2) {
                    rangeWithDots.push(l + 1);
                } else if (i - l !== 1) {
                    rangeWithDots.push('...');
                }
            }
            rangeWithDots.push(i);
            l = i;
        }

        return rangeWithDots;
    }
}

export default new SearchPaginationService();
